<template>

    <div>
        <div v-if="rules.length" class="segmenter-body">
            <v-rule-group v-for="group in rules"
                :key="group.id"
                :group="group">
            </v-rule-group>
        </div>
        <div v-if="!rules.length">
            <v-button size="xs" btn-style="white" @click.native="addRuleGroup">Restrict to Event Properties</v-button>
        </div>
    </div>

</template>

<script>

import RuleGroup from './rules/RuleGroup';

export default {

    components: {
        'v-rule-group': RuleGroup,
    },

    props: {
        model: {
            type: Object,
        },
    },

    data() {
        return {
            op: this.$store.getters['segmenter/op'],
        }
    },

    mounted() {
        this.$store.commit('segmenter/setType', 'event');
        this.$store.commit('segmenter/setModel', this.model);
        this.$store.commit('segmenter/setOp', this.model.op || 'and');
        this.$store.commit('segmenter/setRules', this.model.rules);
    },

    computed: {

        rules() {
            return this.$store.getters['segmenter/rules'];
        },

    },

    watch: {

        op(val) {
            this.$store.commit('segmenter/setOp', val);
        },

    },

    methods: {

        addRuleGroup() {
            this.$store.commit('segmenter/addRuleGroup');
        },

    },

}

</script>
